"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Trinity = exports.TrinityClient = exports.AdobeTracking = exports.GoogleTagManager = void 0;
var google_analytics_1 = require("./subscribers/google_analytics");
Object.defineProperty(exports, "GoogleTagManager", { enumerable: true, get: function () { return google_analytics_1.GoogleTagManager; } });
var adobe_tracking_1 = require("./subscribers/adobe_tracking");
Object.defineProperty(exports, "AdobeTracking", { enumerable: true, get: function () { return adobe_tracking_1.AdobeTracking; } });
var trinity_1 = require("./subscribers/trinity");
Object.defineProperty(exports, "TrinityClient", { enumerable: true, get: function () { return trinity_1.TrinityClient; } });
__exportStar(require("./subscribers/adobe_tracking/adobe_event"), exports);
__exportStar(require("./subscribers/adobe_tracking/adobe_event_handler"), exports);
__exportStar(require("./subscribers/adobe_tracking/adobe_mutation_handler"), exports);
__exportStar(require("./subscribers/adobe_tracking/vuex"), exports);
__exportStar(require("./interfaces"), exports);
__exportStar(require("./subscribers/google_analytics/mutation"), exports);
var Trinity = (function () {
    function Trinity() {
        var subscribers = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            subscribers[_i] = arguments[_i];
        }
        this.subscribers = [];
        this.errorLogger = function () { };
        this.subscribers = subscribers;
    }
    Trinity.prototype.onStateChange = function (mutation, state) {
        for (var _i = 0, _a = this.subscribers; _i < _a.length; _i++) {
            var subscriber = _a[_i];
            try {
                if (subscriber.onStateChange) {
                    subscriber.onStateChange(mutation, state);
                }
            }
            catch (error) {
                this.errorLogger(error);
            }
        }
    };
    Trinity.prototype.onLog = function (message) {
        var optionalParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            optionalParams[_i - 1] = arguments[_i];
        }
        for (var _a = 0, _b = this.subscribers; _a < _b.length; _a++) {
            var subscriber = _b[_a];
            try {
                if (subscriber.onLog) {
                    subscriber.onLog.apply(subscriber, __spreadArray([message], optionalParams, false));
                }
            }
            catch (error) {
                this.errorLogger(error);
            }
        }
    };
    return Trinity;
}());
exports.Trinity = Trinity;
//# sourceMappingURL=index.js.map